var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["limit", { "not-acc-sf": !_vm.accountSummaryFlow }] },
    [
      !_vm.accountSummaryFlow
        ? _c("h2", [
            _vm._v(_vm._s(_vm.$t("Account.Limits.Time." + _vm.limitType)))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.accountSummaryFlow
        ? _c("div", { staticClass: "limit__header" }, [
            _c("h2", [
              _vm._v(_vm._s(_vm.$t("Account.Limits.Time." + _vm.limitType)))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "limit__header__info" }, [
              _vm.currentLimit ||
              _vm.currentLimit === 0 ||
              _vm.maxLimit || _vm.maxLimit === 0
                ? _c("span", [
                    _vm._v("Current: "),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.currentLimit || _vm.maxLimit) +
                          " " +
                          _vm._s(_vm.durationLabel)
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.pendingLimitActivationTime
                ? _c("span", [
                    _vm._v("Pending: "),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.pendingLimit) +
                          " " +
                          _vm._s(
                            _vm.isLimitDeactivation ? "" : _vm.durationLabel
                          )
                      )
                    ])
                  ])
                : _vm._e()
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "limit__info" }, [
        _c("div", [
          _vm._v(
            _vm._s(_vm.$t("Account.Limits.Time." + _vm.limitType + ".Info"))
          )
        ]),
        _vm._v(" "),
        !_vm.currentLimit &&
        _vm.currentLimit !== 0 &&
        !_vm.maxLimit && _vm.maxLimit !== 0
          ? _c("div", [_vm._v(_vm._s(_vm.$t("Account.Limits.Time.NotSet")))])
          : _vm._e(),
        _vm._v(" "),
        !_vm.accountSummaryFlow
          ? _c("div", { staticClass: "limit__info__p" }, [
              _vm.currentLimit ||
              _vm.currentLimit === 0 ||
              _vm.maxLimit || _vm.maxLimit === 0
                ? _c("span", {
                    staticClass: "limit__info__p__label",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t(
                          "Account.Limits.Time." + _vm.limitType + ".Current",
                          {
                            currency: _vm.currency,
                            cl: _vm.currentLimit || _vm.maxLimit
                          }
                        )
                      )
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.pendingLimitActivationTime
                ? _c("span", {
                    staticClass: "limit__info__p__label",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t(
                          "Account.Limits.Time." + _vm.limitType + ".Pending",
                          { currency: _vm.currency, pl: _vm.pendingLimit }
                        )
                      )
                    }
                  })
                : _vm._e()
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.pendingLimitActivationTime
        ? _c("div", {
            staticClass: "limit__activation",
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("Account.Limits.Time.PendingActivation", {
                  at: _vm.pendingLimitActivationTimeFormatted
                })
              )
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.maxLimit
        ? _c("div", {
            staticClass: "limit__max",
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("Account.Limits.Time.Maximum", {
                  ml: _vm.maxLimit,
                  dl: _vm.durationLabel
                })
              )
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "account ctsform" }, [
        _c(
          "div",
          { staticClass: "control-block", class: { filled: _vm.newLimit } },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newLimit,
                  expression: "newLimit"
                }
              ],
              attrs: {
                type: "text",
                inputmode: "numeric",
                id: "qa-" + _vm.limitType,
                autocomplete: "off"
              },
              domProps: { value: _vm.newLimit },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.newLimit = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("label", {
              staticClass: "control-label",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("Account.Limits.Time.Duration", {
                    dl: _vm.durationLabel
                  })
                )
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "save-button-container form-actions" },
          [
            _c(
              "v-btn",
              {
                staticClass: "transactions primary-btn",
                attrs: {
                  disabled: _vm.inputNotValid,
                  color: "success",
                  "x-large": ""
                },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.setLimit()
                  }
                }
              },
              [_c("span", [_vm._v(_vm._s(_vm.$t("Account.Save")))])]
            ),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                staticClass: "transactions secondary-btn",
                attrs: {
                  disabled: !_vm.currentLimit,
                  color: "success",
                  "x-large": ""
                },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.setLimit(true)
                  }
                }
              },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("Account.PlayLimits.Deactivate")))
                ])
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      !_vm.isOnRegistration
        ? _c(
            "ProcessingDialog",
            {
              attrs: {
                isDialogPersistent: true,
                isProcessing: _vm.isProcessing,
                isSuccess: !_vm.transactionError,
                processingTitle: _vm.$t(
                  "Account.PersonalDetails.Dialog.Processing.Title"
                ),
                processingText: _vm.$t(
                  "Account.PersonalDetails.Dialog.Processing.Text"
                ),
                successTitle: _vm.$t("Account.PlayLimits.Dialog.Success.Title"),
                successText: _vm.$t("Account.PlayLimits.Dialog.Success.Text"),
                errorTitle: _vm.$t("Account.PlayLimits.Dialog.Error.Title"),
                closeBtnText: _vm.$t("ProcessingDialog.CloseButtonText")
              },
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _c("div", { attrs: { slot: "text-error" }, slot: "text-error" }, [
                _c(
                  "p",
                  { staticClass: "generic-icon-note" },
                  [
                    _c(
                      "v-icon",
                      { staticClass: "mr-1", attrs: { color: "error" } },
                      [_vm._v("error")]
                    ),
                    _c("span", [_vm._v(_vm._s(_vm.transactionError))])
                  ],
                  1
                )
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f4896e9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f4896e9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/Limits/TimeLimit.vue
// module id = null
// module chunks = 